﻿﻿export interface IBillingDetailRequest {
    donorCenterId: number;
    donorId: number;
    centerAccountNumber: string;
    centerRoutingNumber: string;
    recipientId: number;
    physicianCharges: number;
    anesthesiaCharges: number;
    hospitalCharges: number;
    asaUnitCount: number;
    physicianChargesFile: File;
    anesthesiaChargesFile: File;
    hospitalChargesFile: File;
    centerW9File: File;
    isRecipientCenter: boolean;
}
